/**
 * Shared helpers for HTML-based PDF card renderers.
 * Imported by individual domain PdfCardDef implementations.
 */

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/** Format a "YYYY" or "YYYY-MM" date string as "Mon YYYY". Returns null for empty values. */
export function fmtDate(d: unknown): string | null {
  if (d === null || d === undefined || d === '') return null;
  const parts = String(d).split('-');
  if (parts.length < 2) return parts[0] ?? null;
  const m = parseInt(parts[1], 10);
  if (isNaN(m) || m < 1 || m > 12) return parts[0];
  return `${MONTHS[m - 1]} ${parts[0]}`;
}

/** Format a date range. Uses a styled "Present" span when isCurrent is true. */
export function dateRange(start: unknown, end: unknown, isCurrent?: boolean): string {
  const s = fmtDate(start);
  const e = isCurrent ? '<span class="bp-present">Present</span>' : fmtDate(end);
  if (s && e) return `${s}&nbsp;&ndash;&nbsp;${e}`;
  return (s ?? '') + (e ?? '');
}

/** Escape a value for safe HTML insertion. */
export function esc(val: unknown): string {
  if (val === null || val === undefined) return '';
  return String(val)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Join non-empty parts with the standard metadata separator span. */
export function metaJoin(
  parts: (string | null | undefined)[],
  sep = '<span class="bp-sep">&nbsp;&middot;&nbsp;</span>'
): string {
  return parts.filter(Boolean).join(sep);
}
